import { render, staticRenderFns } from "./AudioComponent.vue?vue&type=template&id=5d21ef99&"
import script from "./AudioComponent.vue?vue&type=script&lang=ts&"
export * from "./AudioComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports